import type { MembershipSchema } from '@zenid/mypage-api';
import { isMembershipActive } from '@zenid/admin-api';
import { getUnixTime, isBefore } from 'date-fns';
import { NFDW_EDU_ZEN_UNIVERSITY } from '#/utils/constants';

export function partitionMemberships(memberships: MembershipSchema[]) {
  const currentMemberships: MembershipSchema[] = [];
  const pastMemberships: MembershipSchema[] = [];

  for (const membership of memberships) {
    // 表示すべき membership であるか (非表示対象以外の role を持つか) を判定する
    const shouldShownMembership = membership.roleAssignings.some(
      (r) => r.name !== NFDW_EDU_ZEN_UNIVERSITY.APPLICANT && r.name !== NFDW_EDU_ZEN_UNIVERSITY.GUARANTOR
    );
    if (!shouldShownMembership) {
      // 非表示対象の membership は現在にも過去にも表示しない
      continue;
    }
    const isActive = isMembershipActive(membership);
    // 現在有効な場合は現在の所属として表示するため早期 continue
    if (isActive) {
      currentMemberships.push(membership);
      continue;
    }
    // membership が有効でなく、leftAt が存在しそれが過去であれば、それは過去の所属であり、それ以外は未来の所属である
    // FIXME: 現在のビルドの都合で ts-lib を直接 import できないため、 date-fns の getUnixTime を直接呼んでいる
    if (membership.leftAt && isBefore(membership.leftAt, getUnixTime(new Date()))) {
      pastMemberships.push(membership);
      continue;
    }
    // 未来の membership は現在表示に用いない
  }

  return { currentMemberships, pastMemberships };
}
